import React 			from 'react';
import ReactDOM 		from 'react-dom';

import BLComponent		from '../../core/_BLComponent.jsx';


export default class CrowdfundingCountdown extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			currentDate: new Date()
		};
	}

	componentDidMount() {
		this.dateUpdater = setInterval(
      () => this.updateDate(),
      1000
    );
	}

	componentWillUnmount() {
		clearInterval(this.dateUpdater);
	}

	updateDate() {
		this.setState({currentDate: new Date()});
	}

	render() {
		const {classes, end} = this.props;
		const remaining = end - this.state.currentDate;
		const clock = {days: '', hours: '', minutes: '', seconds: ''};
		
		if(remaining < 0) {
			clock.days 		= 0;
			clock.hours 	= 0;
			clock.minutes = 0;
			clock.seconds = 0;
		}else{
			clock.days = Math.floor(remaining / (1000 * 60 * 60 * 24))
			clock.hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			clock.minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60))
			clock.seconds = Math.floor((remaining % (1000 * 60)) / 1000)
		}

		return (
			<div className={"bdp-introduce__countdown-clock " + classes}>
				<div className="bdp-introduce__countdown-clock-cell">
					<div className="bdp-introduce__countdown-clock-number">{String(clock.days).padStart(2, '0')}</div>
					<span className="bdp-introduce__countdown-clock-label">Days</span>
				</div>
				<div className="bdp-introduce__countdown-clock-divider">:</div>
				<div className="bdp-introduce__countdown-clock-cell">
					<div className="bdp-introduce__countdown-clock-number">{String(clock.hours).padStart(2, '0')}</div>
					<span className="bdp-introduce__countdown-clock-label">Hours</span>
				</div>
				<div className="bdp-introduce__countdown-clock-divider">:</div>
				<div className="bdp-introduce__countdown-clock-cell">
					<div className="bdp-introduce__countdown-clock-number">{String(clock.minutes).padStart(2, '0')}</div>
					<span className="bdp-introduce__countdown-clock-label">Min</span>
				</div>
				<div className="bdp-introduce__countdown-clock-divider">:</div>
				<div className="bdp-introduce__countdown-clock-cell">
					<div className="bdp-introduce__countdown-clock-number">{String(clock.seconds).padStart(2, '0')}</div>
					<span className="bdp-introduce__countdown-clock-label">Sec</span>
				</div>
			</div>
		);
	}
}